import GLOBAL from '../store/actions/global'

const Loading = {
  install(Vue) {
    Vue.prototype.$loading = function loading(callback, onLoadError) {
      this.$store.dispatch(GLOBAL.LOADING, { callback, onLoadError })
    }
  },
}

export default Loading
